export function PolicyDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.POLICY + '/:param1')
        .setCustomActions({
            'getAll': {
                method: 'GET',
                isArray: true
            },
            'getByName': {
                method: 'GET',
                params: {param1: '@policyName'}
            },
            'validateName': {
                method: 'GET',
                params: {param1: '@policyName'},
                path: '/policies/validate/:param1'
            },
            'savePolicy': {
                method: 'POST',
                notifications: true
            },
            'updatePolicy': {
                method: 'PUT',
                params: {param1: '@name'},
                notifications: true
            },
            'deletePolicy': {
                method: 'DELETE',
                params: {param1: '@policyName'},
                notifications: true
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/policy_dao.js